const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Actor-name hygiene for display: blank, dash, or raw-UUID values
 * render as "Unknown User". Knows nothing about where names come from.
 */
export const displayUserName = (name?: unknown): string => {
  if (!name || typeof name !== "string") return "Unknown User";
  const trimmed = name.trim();
  if (!trimmed || trimmed === "-" || trimmed === "—" || UUID_REGEX.test(trimmed)) {
    return "Unknown User";
  }
  return trimmed;
};
